import { trendItemsApi } from 'container/trendItemsApi';
import { TrendItemsRepository } from 'repository/TrendItemsRepository';

export const trendItemsRepository = new TrendItemsRepository(trendItemsApi);
